/**
 * Conditional class name utility.
 *
 * Accepts strings, numbers, arrays, and objects.
 * Falsy values are filtered out. Object keys with
 * truthy values are included.
 */

type ClassDictionary = Record<string, boolean | null | undefined>;
type ClassValue =
  | string
  | number
  | bigint
  | false
  | null
  | undefined
  | ClassValue[]
  | ClassDictionary;

export function cn(...inputs: ClassValue[]): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === 'string' || typeof input === 'number' || typeof input === 'bigint') {
      classes.push(String(input));
    } else if (Array.isArray(input)) {
      const nested = cn(...input);
      if (nested) classes.push(nested);
    } else if (typeof input === 'object') {
      for (const key in input) {
        if (input[key]) classes.push(key);
      }
    }
  }

  return classes.join(' ');
}
